import { metaAccount } from '@/router/meta-config'
// !FOR DEV!
const permissionKey = 'PAGE'

export default [
  {
    path: '/seo-configs',
    name: 'page-seo-configs',
    component: () => import('@/pages/seo-configs'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/seo-config/new',
    name: 'page-seo-config-new',
    component: () => import('@/pages/seo-config'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/seo-config/:id',
    name: 'page-seo-config',
    component: () => import('@/pages/seo-config'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
